import { AggregateBucketKey, Source } from 'generated/graphql';
import { sourceSerializer } from 'v2/core/entities/fields';
import { IsoLanguageMap } from 'v2/utils/language';
import { getMetadataLabel } from './getMetadataLabel';

interface getDataPointLabelOptions {
  bucket: AggregateBucketKey;
  shouldRemoveFileUploadPrefix: boolean;
}

export function getDataPointLabel({
  bucket,
  shouldRemoveFileUploadPrefix = false,
}: getDataPointLabelOptions): string | undefined {
  if (bucket.labelID) {
    return bucket.label?.displayName;
  }

  const { entitySentiment, language, metadata, source, namespace } = bucket;

  if (source) {
    const sourceName =
      shouldRemoveFileUploadPrefix && source === Source.FileUpload
        ? ''
        : sourceSerializer(source);

    const displayName = namespace
      ? `${sourceName} ${namespace}`.trim()
      : sourceName;

    return displayName;
  }

  if (entitySentiment) {
    return entitySentiment;
  }

  if (language) {
    return language.iso6393 && IsoLanguageMap[language.iso6393];
  }

  if (metadata) {
    return getMetadataLabel(bucket.metadata);
  }

  return;
}
